import { supabase } from '../helper/supabaseClient';

const BUCKET = 'community-images';

function safeExt(filename) {
  const parts = String(filename || '').split('.');
  const ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
  if (!ext || ext.length > 10) return 'jpg';
  return ext;
}

export async function uploadCommunityImage({ file, userId }) {
  if (!file) throw new Error('No file selected');

  const ext = safeExt(file.name);
  const path = `${userId || 'unknown'}/${Date.now()}_${Math.random().toString(16).slice(2)}.${ext}`;

  const { error: uploadError } = await supabase.storage
    .from(BUCKET)
    .upload(path, file, { upsert: false });

  if (uploadError) throw new Error(uploadError.message || 'Failed to upload image');

  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  const publicUrl = data?.publicUrl;
  if (!publicUrl) throw new Error('Could not get public URL for uploaded image');

  return { publicUrl, path, bucket: BUCKET };
}

